{
  "actionbar.actions": "Akcie",
  "actionbar.actionsAvailable": "Dostupné akcie.",
  "actionbar.clearSelection": "Vymazať výber",
  "actionbar.selected": "Vybrané položky: {count}",
  "actionbar.selectedAll": "Všetky vybraté položky",
  "button.pending": "čakajúce",
  "calendar.invalidSelection": "{selectedCount, plural, one {Vybratý dátum} other {Vybraté dátumy}}: nedostupné.",
  "contextualhelp.help": "Pomoc",
  "contextualhelp.info": "Informácie",
  "datepicker.endTime": "Čas ukončenia",
  "datepicker.startTime": "Čas začiatku",
  "datepicker.time": "Čas",
  "dialog.alert": "Upozornenie",
  "dialog.dismiss": "Zrušiť",
  "dropzone.replaceMessage": "Presuňte súbor, ktorý chcete nahradiť",
  "inlinealert.informative": "Informácie",
  "inlinealert.negative": "Chyba",
  "inlinealert.notice": "Upozornenie",
  "inlinealert.positive": "Úspech",
  "label.(optional)": "(nepovinné)",
  "label.(required)": "(povinné)",
  "menu.moreActions": "Ďalšie akcie",
  "picker.placeholder": "Vybrať…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Načítava sa...",
  "table.loadingMore": "Načítava sa viac...",
  "table.resizeColumn": "Zmeniť veľkosť stĺpca",
  "table.sortAscending": "Zoradiť vzostupne",
  "table.sortDescending": "Zoradiť zostupne",
  "tag.actions": "Akcie",
  "tag.hideButtonLabel": "Zobraziť menej",
  "tag.noTags": "Žiadne",
  "tag.showAllButtonLabel": "Zobraziť všetko ({tagCount, number})",
  "breadcrumbs.more": "Ďalšie položky",
  "combobox.noResults": "Žiadne výsledky",
  "notificationbadge.indicatorOnly": "Nová aktivita",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}